import { handleActions } from 'redux-actions';
import {
  ticketsLoading,
  ticketsLoaded,
  ticketSelected,
  ticketFailed
} from '../actions/ticket';

import { resetBooking } from '../actions/booking';

const initialState = {
  ticketsLoading: false,
  ticketsLoaded: false,
  tickets: [],
  selectedTicket: {},
  selectedTicketCode: '',
  hasSelectedTicket: false
};

const ticketReducer = handleActions({
  [ticketsLoading]: state => ({
    ...state,
    ticketsLoading: true,
    ticketsLoaded: false,
    tickets: [],
    selectedTicketCode: '',
    selectedTicket: {}
  }),
  [ticketsLoaded]: (state, action) => ({
    ...state,
    ticketsLoading: false,
    ticketsLoaded: true,
    tickets: action.payload,
    selectedTicket: {},
    selectedTicketCode: ''
  }),
  [ticketSelected]: (state, action) => ({
    ...state,
    selectedTicket: action.payload,
    selectedTicketCode: action.payload.code,
    hasSelectedTicket: true
  }),
  [ticketFailed]: state => ({
    ...state,
    ticketsLoading: false,
    ticketsLoaded: false
  }),
  [resetBooking]: () => ({
    ...initialState
  })
}, initialState);

export default ticketReducer;



// WEBPACK FOOTER //
// ./src/reducers/ticket.js